/**
 * 前端權限判斷（v2.32.0）
 *
 * ⚠️ **這一層只決定「畫不畫、進不進得去」，不是安全邊界。**
 * 真正的把關在後端 `Backend/jwt_protection.py` 的 before_request hook：
 * 沒有 cap 的人就算硬打網址、或直接 curl API，一樣會被 403。
 * 這裡存在的理由是體驗 —— 不要讓使用者看到一個點進去只會壞掉的選單。
 *
 * 判斷規則是「舊的 permission」AND「新的 requiredCap」：
 *   - permission：admin / super 看得到全部，normal 只看得到 permission==='normal' 的頁
 *   - requiredCap：選填，再要求一個 cap（'view_revenue' / 'manage_users'）
 *
 * 刻意用 AND 疊加而不是把 permission 換掉 —— 既有那套邏輯散在 Admin.js
 * 與 Sidebar.js 共 6 處，全部重寫的回歸風險遠大於收益。
 */

/** 這個使用者有沒有某個 cap。user 可能是 undefined（還沒載入）→ 一律 false。 */
export function hasCap(user, cap) {
  if (!cap) return true; // 沒指定 requiredCap 的路由 = 不額外要求
  if (!user || !user.caps) return false; // fail-closed：資料還沒到就當作沒有
  return Boolean(user.caps[cap]);
}

/** permission 這一層過不過（維持 v2.32.0 之前的原始邏輯，一字未改）。 */
export function passesPermission(user, route) {
  if (!user) return false;
  return (
    user.permission === "admin" ||
    user.permission === "super" ||
    user.permission === route.permission
  );
}

/** 這個使用者能不能用這條路由。permission AND requiredCap。 */
export function canAccessRoute(user, route) {
  if (!user || !route) return false;
  return passesPermission(user, route) && hasCap(user, route.requiredCap);
}

/** 找出這個使用者第一個進得去的頁（登入後的預設落地頁）。 */
export function firstAccessibleRoute(user, routes) {
  return routes.find(
    (r) => r.layout === "/admin" && !r.invisible && canAccessRoute(user, r)
  );
}
